export const SET_SELECTED_PROGRAM = "SET_SELECTED_PROGRAM";

export function setSelectedProgram(programReqBody) {
  return {
    type: SET_SELECTED_PROGRAM,
    payload: programReqBody,
  };
}
